// userSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  isEmailVerified: boolean;
  authEmail: string;
  authPassword: string;
  authUser: any;
  authPhone: string;
}

const initialState: AuthState = {
  isEmailVerified: false,
  authEmail: "",
  authPassword: "",
  authUser: null,
  authPhone: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthUser: (state, action: PayloadAction<any>) => {
      state.authUser = action.payload;
    },
    setAuthEmail: (state, action: PayloadAction<string>) => {
      state.authEmail = action.payload;
    },
    setAuthPassword: (state, action: PayloadAction<string>) => {
      state.authEmail = action.payload;
    },
    setIsEmailVerified: (state, action: PayloadAction<boolean>) => {
      state.isEmailVerified = action.payload;
    },
    setAuthPhone: (state, action: PayloadAction<string>) => {
      state.authPhone = action.payload;
    },
  },
});

export const {
  setAuthUser,
  setAuthEmail,
  setAuthPassword,
  setIsEmailVerified,
  setAuthPhone,
} = authSlice.actions;
export default authSlice.reducer;
